import React, { FC } from 'react'
import { Main as MainLayout } from '../layouts'
import { PropsWithRootStore } from 'constants/types'
import { AutopilotSteps } from 'components/Phantom/_sections/AutopilotSteps'
import { PersonalStewardScroll } from 'components/Phantom/_sections/PersonalStewardScroll'
import { PerfectNightSleep } from 'components/Phantom/_sections/PerfectNightSleep'
import { EnergySavings } from 'components/Phantom/_sections/EnergySavings'
import { AutopilotCompareTable } from 'components/Phantom/_sections/AutopilotCompareTable'
import { ScrollSequenceStatic } from 'components/Phantom/_sections/ScrollSequenceStatic'
import { AutopilotHero } from 'components/Phantom/_sections/AutopilotHero'
import { Sticky } from 'components/WebEv/CoverLP2023/Sticky'
import { PriceManager } from 'prices'
import { ClientOnly } from 'components/ClientOnly'

export const Autopilot: FC<PropsWithRootStore> = (props) => {
	const { settingsStore, priceStore } = props.rootStore

	const showEnergySavings = settingsStore.currentRegion === '' || settingsStore.currentRegion === 'us'
	return (
		<MainLayout>
			<Sticky
				stickyName={'Pod 4'}
				price={priceStore.pod4PriceFormatted}
				strikePrice={priceStore.pod4ComparePriceFormatted}
				monthlyPrice={priceStore.pod4MonthlyPriceFormatted}
				months={priceStore.coverMaxMonthsAtZeroInterest}
				showFinancing={PriceManager.currencyHasAffirm(priceStore.currency)}
				discount={priceStore.podDiscountFormatted}
				discountLine={settingsStore.settings.stickyCardTag}
				discountLineMobile={settingsStore.settings.stickyCardTagMobile}
				setHeight={settingsStore.setCoverStickyHeight}
			/>
			<AutopilotHero />
			<ClientOnly>
				<PersonalStewardScroll />
				<PerfectNightSleep />
				<AutopilotSteps />
				{showEnergySavings && <EnergySavings />}
				<AutopilotCompareTable />
				<ScrollSequenceStatic />
			</ClientOnly>
		</MainLayout>
	)
}
